import React, { useState } from "react";
import axios from "axios";
import {
  Button,
  TextInput,
  Divider,
  Modal,
  Text,
  List,
  Flex,
  ThemeIcon,
  UnstyledButton,
} from "@mantine/core";
import { IconBomb } from "@tabler/icons-react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const confirmText = "DELETEMYACCOUNT";

export default function UserDeleteAccount() {
  const { t } = useTranslation();
  const [isOpen, setOpen] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [confirmValue, setConfirmValue] = useState("");
  const [loading, setLoading] = useState(false);

  const userInfo = useSelector((state) => state.user);

  function onClose() {
    setOpen(false);
    setConfirm(false);
    setConfirmValue("");
    setLoading(false);
  }

  function onSubmit() {
    setLoading(true);
    const req = {
      comment: `User requested account deletion from member app. ID: ${userInfo.user_location_id}`,
    };

    axios
      .post(`/users/delete-request/`, req)
      .then(() => {
        window.location.reload();
      })
      .catch((err) => {
        setLoading(false);
        toast.error(err);
      });
  }

  return (
    <div>
      <UnstyledButton onClick={() => setOpen(true)}>
        <Flex align="center">
          <ThemeIcon variant="subtle" color="gray" mr="sm">
            <IconBomb size={20} />
          </ThemeIcon>
          <Text>{t("user_app:delete_account")}</Text>
        </Flex>
      </UnstyledButton>
      <Modal opened={isOpen} onClose={onClose}>
        {confirm ? (
          <>
            <Text mb="sm">Type {confirmText} in the text field below</Text>
            <TextInput
              value={confirmValue}
              onChange={(e) => setConfirmValue(e.target.value)}
            />
            <Divider mt="lg" mb="sm" />
            <Button
              disabled={confirmValue !== confirmText}
              loading={loading}
              onClick={onSubmit}
              fullWidth
            >
              {t("user_app:delete_account")}
            </Button>
            <Flex justify="center">
              <Button
                mt="md"
                variant="subtle"
                color="gray"
                size="xs"
                c="dimmed"
                onClick={onClose}
              >
                {t("user_app:delete_account_cancel")}
              </Button>
            </Flex>
          </>
        ) : (
          <>
            <Text>{t("user_app:delete_account_confirm_title")}</Text>
            <Text mt="sm" mb="sm">
              {t("user_app:delete_account_actions_title")}:
            </Text>
            <List>
              <List.Item>
                {t("user_app:delete_account_actions_item_1")}
              </List.Item>
              <List.Item>
                {t("user_app:delete_account_actions_item_2")}
              </List.Item>
              <List.Item>
                {t("user_app:delete_account_actions_item_3")}
              </List.Item>
              <List.Item>
                {t("user_app:delete_account_actions_item_4")}
              </List.Item>
            </List>
            <Divider mt="lg" mb="lg" />
            <Button fullWidth color="red" onClick={onClose}>
              {t("user_app:delete_account_no")}
            </Button>
            <Flex justify="center">
              <Button
                mt="md"
                variant="subtle"
                color="gray"
                size="xs"
                c="dimmed"
                onClick={() => setConfirm(true)}
              >
                {t("user_app:delete_account_yes")}
              </Button>
            </Flex>
          </>
        )}
      </Modal>
    </div>
  );
}
